import ExamTemplate from 'components/standard/mudmanage/Examtemplate'

function Examtemplate() {
  return <ExamTemplate />
}

export default Examtemplate;
